/**
 *
 * PROJECT eVessel
 * Developed by:  3WebBox LLC - 2023
 * 
 * Disclaimer: Please make sure to read related documentation before
 * making any changes to the code. Modify the code under your own
 * responsibility. for help please contact 3WebBox.
 * 
 * https://3webbox.com  : support@3webbox.com
 * 
 * 
 */

import { useState, useEffect, ReactElement } from 'react';

import { DeleteFilled, DeleteOutlined, FileFilled, ThunderboltFilled } from "@ant-design/icons";
import { Alert, Button, Col, Divider, Dropdown, Image, Input, Popconfirm, Row, Select, Space, Spin, Switch, Tooltip, Typography } from "antd";
import EVAPI from '../lib/ev_lib/main';
import moment from 'moment';
import { URLQuery } from '../util/url_queries';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import Resizer from "react-image-file-resizer";
import { green, grey, lime } from '@ant-design/colors';
import { userSettings } from '../lib/user_settings';


export function PreviewImage(props:any) {
  const [image, setImage] = useState<any>(null);

  useEffect(() => {
    if(!image) openDocument()
  }, []);

  const openDocument = async () => {
    var EV:any = new EVAPI;
    EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
    EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
    EV.authToken = localStorage.getItem('auth_token');
    EV.uuid = props.uuid;
    EV.purpose = props.purpose;
    EV.purposeUuid = props.purposeUuid;
    EV.accessCode = props.accessCode;

    var res:any = await EV.openDocuments();

    setImage(URL.createObjectURL(res));
    return null;
  }

  return <Image
    src={image}
    height={100}
    fallback="data:image/png;base64,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"
  />
}

export default function Documents(props:{
  purpose:'cargo'|'packing order'|'container'|'exporter'|'contact'|'packing plan',
  purposeUuid: string|null|undefined,
  optimization?:{
    max_width?:number,
    quality?:number
  },
  category?: 'general'|'title',
  allowManage?: boolean,
  allowUpload?: boolean,
  title?: string|undefined,
  titleLevel?: 5|2|1|3|4,
  documents?:any[],
  accessCode?:string
}) {
  // get the user settings object
  let userSettingsOptimization:boolean = userSettings('image_optimization_default_enabled') === 'y' ? true : false;

  var uploadForm = Math.random();
  
  const [isDownloadingAll, setIsDownloadingAll] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState<any>(null);
  const [documents, setDocuments] = useState<any[]>(props.documents||[]);
  const [optimizeUpload, setOptimizeUpload] = useState<boolean>(userSettingsOptimization);
  const [onlineOptimization, setOnlineOptimization] = useState<boolean>(false);

  useEffect(() => {
    getDocuments()
  }, []);

  const getDocuments = async () => {
    if(props.documents && props.documents.length > 0) {
      setDocuments(props.documents);
      return;
    }

    if(isLoadingDocuments || !props.purposeUuid) return;
    setIsLoadingDocuments(true);
    
    var EV:any = new EVAPI;
    EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
    EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
    EV.authToken = localStorage.getItem('auth_token');
    EV.purpose = props.purpose;
    EV.purposeUuid = props.purposeUuid;
    EV.category = props.category;
    EV.showAll = 'y';

    var res:any = await EV.getDocuments();
    
    if(!res || res.status !== 'success') {
      // > handle error
      console.error('Failed to load', res)
    }

    else {
      setDocuments([...res.data]);
    }
    
    setIsLoadingDocuments(false);    
    return;
  }

  const uploadDocument = async (file:any, optimize?:boolean, onlineOptimization?:boolean) => {
    if(!file) {
      console.error('No file selected', file);
      return;
    }

    const data:any = new FormData();
    data.append("purpose", props.purpose);
    data.append("purpose_uuid", props.purposeUuid);

    var optimizableExtensions = [
      'jpg',
      'jpeg',
      'jfif',
      'pjpeg',
      'png',
      'gif'
    ];

    // collect the file information
    var extension = file.name?.substr(file.name.lastIndexOf('.') + 1);

    // convert extension to lowercase
    extension = extension?.toLowerCase();

    // check if the uploaded document / file is a support image
    if(!optimizableExtensions.includes(extension)) {
      optimize = false;
    }
    
    // handle document based on extension and purpose
    if(optimize && onlineOptimization) {
      data.append("optimize", 'y');
    }
    if(optimize && !onlineOptimization) {
      var defaultOptimizationValues = {
        max_width: props?.optimization?.max_width||800,
        quality: props?.optimization?.quality||60
      }
      
      try {
        var resizedImage = await new Promise((resolve) => {
          Resizer.imageFileResizer(
            file,
            defaultOptimizationValues.max_width,
            defaultOptimizationValues.max_width,
            extension,
            defaultOptimizationValues.quality,
            0,
            (uri) => resolve(uri),
            "file"
          );
        });

        file = resizedImage;
        
        // this option to the request
        data.append("optimized", 'y');
      }
      catch(e) {
        // > handle optimization error
        console.error(
          'Failed to optimize the requested document', 
          e
        );

        return;
      }
    }

    if(props.category) {
      data.append("category", props.category);
    }
    
    var EV:any = new EVAPI;
    EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
    EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
    EV.authToken = localStorage.getItem('auth_token');
    EV.useAppend = true;
    EV.body = data;

    // attached the file
    data.append("document", file);

    var res:any = await EV.uploadDocument();
    
    if(!res || res.status !== 'success') {
      // > handle error
      console.error('Failed to upload', res)
    }

    else {
      var tempDocs = documents;
      tempDocs.push(res.data);
      setDocuments(tempDocs);
    }

    return null;
  }

  const deleteDocument = async (uuid:string) => {
    var EV:any = new EVAPI;
    EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
    EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
    EV.authToken = localStorage.getItem('auth_token');
    EV.uuid = uuid;

    var res:any = await EV.deleteDocument();
    
    if(!res || res.status !== 'success') {
      // > handle error
      console.error('Failed to upload', res)
    }

    else {
      var docElement = document.getElementById(uuid);

      if(docElement) {
        docElement.style.display = 'none';
      }
    }
    
    return null;
  }

  const _renderScreen = () => {
    if(!props.purposeUuid) return <Alert 
      message="Save the record enable this section." 
      type="warning" 
    />

    else return <>
      <div 
        style={{
          borderRadius: 10, 
          border: '1px solid rgb(200, 200, 200, 0.2)', 
          width: '100%',
          minHeight: 110,
          marginBottom: 10
        }}
      >
        <Image.PreviewGroup >
          {documents && documents.map((doc:any, key:number) => {
            if(
              (
                props.category
                && doc.category !== props.category
              )
              || !doc.ext
              || !['png', 'jpeg', 'jpg', 'gif'].includes(doc.ext.toLowerCase())
            ) return null;
            
            return <div 
              className={key.toString()}
              id={doc.uuid}
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                position: 'relative'            
              }}
            >
              <div 
                style={{
                  margin: 3,
                  overflow: 'hidden',
                  borderRadius: 10,
                }}
              >
                <PreviewImage 
                  uuid={doc.uuid}
                  purpose={props.purpose}
                  purposeUuid={props.purposeUuid}
                  accessCode={props.accessCode} 
                />
              </div>
              {(props.allowManage) && <>
                <div style={{margin: 3, position: 'absolute', bottom: 5, left: 5}}>
                  <div style={{display: 'inline-block', marginRight: 7}}>
                    <Popconfirm
                      placement="top"
                      title={'Delete confirmation'}
                      description={'Are you sure you want to delete this selected document?'}
                      onConfirm={() => deleteDocument(doc.uuid)}
                      okText="Confirm"
                      cancelText="Cancel"
                    >
                      <Button 
                        danger 
                        size={'small'} 
                        type={'primary'}
                        shape={'circle'}
                        icon={<DeleteFilled />}
                      />
                    </Popconfirm>
                  </div>
                  <div 
                    style={{
                      display: 'inline-block',
                      borderRadius: 10
                    }}
                  >
                    <Popconfirm
                      placement="top"
                      title={'Optimize Image'}
                      description={'Optimizing the image online will use optimization credit. '
                        + 'Are you sure you want to proceed?'}
                      onConfirm={() => null}
                      okText={"Confirm"}
                      cancelText={"Cancel"}
                    >
                      <Button
                        style={{
                          background: (doc.optimized && doc.optimized === 'y') ? green[5] : grey[5]
                        }}
                        disabled={(doc.optimized && doc.optimized === 'y')}
                        size={'small'} 
                        shape={'circle'}
                        icon={<ThunderboltFilled style={{color: 'white'}} /> }
                      />
                    </Popconfirm>
                  </div>
                </div>
              </>}
            </div>
          })}
        </Image.PreviewGroup>

        <Divider children={'Documents'} />

        {documents && documents.map((doc:any, key:number) => {
          if(
            (
              props.category
              && doc.category !== props.category
            )
            || !doc.ext
            || ['png', 'jpeg', 'jpg', 'gif'].includes(doc.ext.toLowerCase())
          ) return null;
          
          var openAction = async () => {
            var EV:any = new EVAPI;
            EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
            EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
            EV.authToken = localStorage.getItem('auth_token');
            EV.uuid = doc.uuid;
            EV.purpose = props.purpose;
            EV.purposeUuid = props.purposeUuid;
            EV.accessCode = props.accessCode;
        
            var res:any = await EV.openDocuments();
            window.open(URL.createObjectURL(res));
          }

          return <Row
            id={doc.uuid}
            gutter={5}
            style={{
              margin: 5, 
              marginTop: 10, 
              marginBottom: 10,
              cursor: 'pointer'
            }}
          >
            <Col span={1} onClick={openAction}>
              <FileFilled style={{color: '#777', fontSize: 20}} />
            </Col>
            <Col span={17} onClick={openAction}>
              <Typography.Text>{doc.uuid}.<Typography.Text strong>{doc.ext}</Typography.Text></Typography.Text>
            </Col>
            <Col span={6} style={{textAlign: 'right'}}>
              <Typography.Text type={'secondary'}>{moment(doc.created_at).fromNow()}</Typography.Text>
              {(props.allowManage) && <Popconfirm
                placement="top"
                title={'Delete confirmation'}
                description={'Are you sure you want to delete this selected document?'}
                onConfirm={() => deleteDocument(doc.uuid)}
                okText="Confirm"
                cancelText="Cancel"
                >
                <Button 
                  type={'link'} 
                  size={'small'} 
                  icon={<DeleteOutlined style={{color: 'red'}} />} 
                />
              </Popconfirm>}
            </Col>
          </Row>
        })}
      </div>

      <Space wrap>
        {(props.allowUpload) && <>
          <Input
            type="file"
            accept='image/*, application/pdf'
            multiple 
            id={`${uploadForm}`}
            name="upload-general-selector"
            style={{display: 'none'}}
            onChange={async (event:any) => {
              if(event && event.target && event.target.files) {
                var files:any = event.target.files;
                
                // process upload for each file
                if(files) {
                  setIsUploading(true);

                  for(var i = 0; i < files.length; i++) {
                    await uploadDocument(files[i], optimizeUpload, onlineOptimization);

                    if( (i + 1) === files.length ) {
                      setIsUploading(false);
                    }
                  }
                }
              }
            }} 
          />

          <Switch
            loading={isUploading}
            style={{backgroundColor: optimizeUpload ? green[5] : undefined}}
            defaultChecked={optimizeUpload}
            onChange={(checked) => setOptimizeUpload(checked)}
            checkedChildren={'Enabled'}
            unCheckedChildren={'Disabled'}
          />
          
          <Typography.Text>
            Image Optimization
          </Typography.Text>

          <Select
            value={onlineOptimization}
            defaultValue={false}
            onChange={(value) => setOnlineOptimization(value)}
            options={[
              {value: false, label: <span>Do not use online optimizer</span>},
              {value: true, label: <span>Use online optimizer</span>}
            ]}
          />

          <Button
            children={'Upload'}
            loading={isUploading}
            disabled={isUploading}
            onClick={() => {
              document.getElementById(`${uploadForm}`)?.click()
            }}
          />
        </>}

        <Button
          children={'Download All'}
          loading={isDownloadingAll}
          disabled={isDownloadingAll||(documents?.length < 1)}
          onClick={() => {
            // download all
            if(!documents || documents.length < 1) {
              // > handle no docuemnts
            }

            // create the zip file
            var zip = new JSZip;
            var totalMatchingDocuments = () => {
              var count = 0;
              
              for(var i = 0; i < documents.length; i++) {
                if(
                  props.category
                  && documents[i].category === props.category
                  && documents[i].ext
                ) count++;

                else if (
                  !props.category
                  && documents[i].ext
                ) count++;
              };

              return count;
            } 

            // loop and add to the zip file
            documents.map(async (doc:any, key:number) => {
              if(
                (
                  props.category
                  && doc.category !== props.category
                )
                || !doc.ext
              ) return null;
              
              var EV:any = new EVAPI;
              EV.debug = process.env.REACT_APP_MODE === "development" ? true : false;
              EV.baseAPI = URLQuery('targetDomain', window)||localStorage.getItem('target_domain');
              EV.authToken = localStorage.getItem('auth_token');
              EV.uuid = doc.uuid;
              EV.purpose = props.purpose;
              EV.purposeUuid = props.purposeUuid;
              EV.accessCode = props.accessCode;
          
              var res:any = await EV.openDocuments();
              
              zip.file(`${doc.uuid}.${doc.ext}`, res);
              
              if((key + 1) === totalMatchingDocuments()) zip
              .generateAsync({type: "blob"})
              .then(function (content) {
                // file name to be the first 8 chars of the uuid
                var uuidName:string|undefined = props.purposeUuid?.substring(0, 10);
                FileSaver.saveAs(content, `${props.purpose}_${uuidName}_${Date.now()}.zip`);
              });
            });
          }}
        />
      </Space>
    </>
  }

  return <>
    {props.title && <Typography.Title level={props.titleLevel||2} children={props.title} />}

    {_renderScreen()}
  </>
}